'use client';

import {
  SessionProvider,
  signOut as nextAuthSignOut,
  useSession
} from 'next-auth/react';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  return <SessionProvider>{children}</SessionProvider>;
}

export function useAuth() {
  const { data: session, status } = useSession();

  return {
    user: session?.user ?? null,
    session,
    loading: status === 'loading',
    signOut: async () => {
      await nextAuthSignOut({ callbackUrl: '/' });
    }
  };
}
